module.exports = __webpack_public_path__ + "img/HZ-T1472.7fe26b0b.jpg";